import { AxiosInstance } from 'axios';

export function withClientToken(clientToken: string, axios: AxiosInstance) {
  axios.defaults.headers.common['Client-Authorization'] = `Token ${clientToken}`;
}
